import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setUserLoginStatus } from "./store/userStatus";
import CustomerDashboard from "./screens/dashboard";
import CustomerHome from "./screens/home";
import CustomerLogin from "./screens/login";
import CreateMoiToken from "./screens/create-token";
import CustomerUpcomingEvents from "./screens/upcoming-events";
import TokenList from "./screens/token-list";
import CustomerRegister from "./screens/register";
import OTPScreen from "./screens/otp-screen";
import MoiList from "./screens/moi-list";
import CustomerSettings from "./screens/settings";
// import VendorSearch from "./screens/vendor-search";
import LiveTracker from "./screens/live-tracker";
import ScanQrCode from "./screens/scan-qr";

// Private Route Wrapper
const PrivateRoute = () => {
  const { userLoggedIn } = useSelector((state) => state.userStatus);
  const token = localStorage.getItem("dwt-cust-tok");
  const location = useLocation();

  if (!userLoggedIn || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
};

// Public Route Wrapper
const PublicRoute = () => {
  const { userLoggedIn } = useSelector((state) => state.userStatus);
  const token = localStorage.getItem("dwt-cust-tok");

  if (userLoggedIn && token) {
    return <Navigate to="/dashboard/home" replace />;
  }
  return <Outlet />;
};

const AppNavigation = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dwt-cust-tok");
    if (token) {
      dispatch(setUserLoginStatus(true));
    } else {
      dispatch(setUserLoginStatus(false));
    }
    setLoading(false); // Loading complete
  }, [dispatch]);

  if (loading) {
    return <div>Loading...</div>; // Placeholder for loading state
  }

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" Component={CustomerLogin} />
          <Route path="/register" Component={CustomerRegister} />
          <Route path="/verify-mobile" Component={OTPScreen} />
        </Route>

        {/* Guest Route (Accessible by logged in and logged out users) */}
        <Route path="/quick-token" Component={CreateMoiToken} />
        <Route path="/scan-qr" Component={ScanQrCode} />

        {/* Private Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" Component={CustomerDashboard}>
            <Route path="home" Component={CustomerHome} />
            <Route path="scan-qr" Component={ScanQrCode} />
            <Route path="create-token" Component={CreateMoiToken} />
            <Route path="events-list" Component={CustomerUpcomingEvents} />
            <Route path="token-list" Component={TokenList} />
            <Route path="moi-note" Component={MoiList} />
            {/* <Route path="find-vendors" Component={VendorSearch} /> */}
            <Route path="settings" Component={CustomerSettings} />
            <Route path="live-tracker" Component={LiveTracker} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppNavigation;
